
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/medicalsoftwarequotes",
      function () {
        return require("private-next-pages/medicalsoftwarequotes/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/medicalsoftwarequotes"])
      });
    }
  